import * as queryString from "query-string";

export const useHash = (options?: { arrayKeys?: string[] }) => {
    const location = window.location;
    const result = queryString.parse(location.hash) as any;
    if (options?.arrayKeys) {
        options.arrayKeys.forEach((key) => {
            if (!Array.isArray(result[key])) {
                // Convert single elements to array
                result[key] = [result[key]];
            }
        });
    }

    return result;
};
